import axios from "axios";
import Toast from '@/common/toast/index.js'
import loading from "@/common/loading/index.js";
import {STATUS_CODE} from "@/common/constants.js";
import store from "@/store/index.js";


axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_ROOT;

// 请求拦截器
axios.interceptors.request.use(function (config) {
  if(store.state.headers.source) {
    config.headers['source'] = store.state.headers.source;
  }
  if(store.state.headers.token) {
    config.headers['token'] = store.state.headers.token;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 响应拦截器
axios.interceptors.response.use(res => {
  let code = res.data.errorCode;
  switch (code) {
    case STATUS_CODE.SUCCESS_CODE:
    case STATUS_CODE.INACCESSIBLE_CODE:
    case STATUS_CODE.SUCCESS_COURIER_CODE:
    case STATUS_CODE.SUCCESS_NO_APP_LOGIN:
    case STATUS_CODE.SUCCESS_NOT_BIND:
      return res;

    default:
      Toast({
        message: `${res.data.errorMsg}`,
        duration: 2000,
      });
      loading && loading.hide();
      return Promise.reject();
  }
}, function (error) {
  return Promise.reject(error);
});


export default axios;
